module.exports = __webpack_public_path__ + "img/fire.83150a5b.svg";